export default __webpack_public_path__ + "static/media/Bard.f6b83678.png";